<template>
  <div
    id="scraped-articles-list"
    :class="{padding : viewType === 'Editor'}"
  >
    <p v-if="!hasArticles">
      No Content Items Available
    </p>
    <content-item-card
      v-else
      v-for="(article, index) in GET_SUCCESSFULLY_SCRAPED_CONTENT_ITEMS"
      class="bg-secondary"
      :id="`article-${article.encodedExternalId}`"
      :key="index"
      :index="index"
      :article="article"
      :data-test="`content-list-item-${index}`"
    />
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import * as contentTypes from '@/modules/content/store/types';
import ContentItemCard from '@/modules/content/components/Articles/ContentItemCard.vue';

export default {
  name: 'SuccessfullyScrapedContentItems',
  components: {
    ContentItemCard,
  },
  methods: {
  },
  computed: {
    ...mapGetters('content', [
      contentTypes.GET_IN_PROGRESS_CONTENT_ITEMS,
      contentTypes.GET_SUCCESSFULLY_SCRAPED_CONTENT_ITEMS,
    ]),
    ...mapState('campaigns', [
      'viewType',
    ]),
    hasArticles() {
      return this.GET_IN_PROGRESS_CONTENT_ITEMS?.length || this.GET_SUCCESSFULLY_SCRAPED_CONTENT_ITEMS?.length;
    },
  },
};
</script>
<style lang="scss" scoped>
.padding {
  padding-bottom: 75px;
}
</style>
